import { Signin, Signup, Forgot, NotFound, CreateProfile } from '../components';

import React, { useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Terms from './Terms';
import { AuthProvider, useAuth } from '../contexts/AuthContext';
import Dashboard from './Dashboard';
import Profile from './Profile';
import Postjob from './Postjob';
import Success from './Success';
import UpdateJob from './UpdateJob';
import NoAccess from './NoAccess';
import AdRecord from './AdRecord';
import Applications from './Applications';
import Home from './Home';
import Referrals from './Referrals';
import JobSearch from '../jobs/JobSearch';
import JobPage from '../jobs/JobPage';

function Landing() {
  return (
    <>
      <Router>
        <Routes>
          {/* Public national job search (GROWTH-004): outside AuthProvider, so it renders at once
              instead of waiting for Firebase (the server-rendered HTML stays until React replaces it). */}
          <Route path="/jobs" element={<JobSearch />} />
          <Route path="/jobs/in/:province" element={<JobSearch />} />
          <Route path="/jobs/in/:province/:city" element={<JobSearch />} />
          <Route path="/jobs/:id" element={<JobPage />} />
          <Route path="/jobs/:id/:slug" element={<JobPage />} />
          <Route path="*" element={<EmployerApp />} />
        </Routes>
      </Router>
    </>
  );
}

function EmployerApp() {
  return (
    <AuthProvider>
          <Routes>
            <Route exact path="/sign-up" element={<Signup />}></Route>

            <Route exact path="/" element={<Home />}></Route>
            <Route exact path="/sign-in" element={<Signin />}></Route>

            <Route exact path="/terms" element={<Terms />}></Route>

            <Route exact path="/forgot-password" element={<Forgot />}></Route>

            <Route exact path="/dashboard" element={<Dashboard />}></Route>
            <Route
              exact
              path="/dashboard/update/:jobId"
              element={<UpdateJob />}
            ></Route>
            <Route
              exact
              path="/dashboard/record/:jobId"
              element={<AdRecord />}
            ></Route>
            <Route
              exact
              path="/dashboard/applications/:jobId"
              element={<Applications />}
            ></Route>
            <Route exact path="/dashboard/referrals" element={<Referrals />}></Route>
            <Route exact path="/dashboard/*" element={<Dashboard />}></Route>

            <Route exact path="/profile" element={<Profile />}></Route>
            <Route exact path="/profile/*" element={<Profile />}></Route>

            <Route
              exact
              path="/create-profile"
              element={<CreateProfile />}
            ></Route>

            <Route exact path="/post-job" element={<Postjob />}></Route>
            <Route exact path="/success" element={<Success />}></Route>

            <Route exact path="/no-access" element={<NoAccess />}></Route>

            <Route exact path="*" element={<NotFound />}></Route>
          </Routes>
    </AuthProvider>
  );
}

export default Landing;
